import React from 'react';
import { Button, Tooltip, Tag, Table } from 'antd';
import global from '../../../common/utility/global';

export default function GeneralTable(props) {
    return (
        <Table
            className="table-general"
            dataSource={props.pagination.data}
            scroll={{ x: true }}
            size="small"
            style={{ overflowX: "auto" }}
            /*         pagination={{
                        total: props.pagination.total,
                        current: props.pagination.page,
                        pageSize: props.pagination.pageSize,
                        showTotal: (total) => `${total} Registro(s) encontrado(s).`
                    }} */
            //rowKey={(record) => record.id}
            title={() => (
                <div style={{ width: "100%", textAlign: "right" }}>
                    <div className="custom-options">
                        {props.onExportExcel === undefined ? null : (
                            <Button
                                ghost
                                type="success"
                                icon="file-excel"
                                onClick={props.onExportExcel}
                                style={{ color: "#3fb703" }}
                                loading={props.loadingExcel}
                            >
                                Excel
                            </Button>
                        )}
                    </div>
                </div>
            )}
            columns={[
                {
                    title: 'Código de Referencia',
                    dataIndex: 'codigoReferencia',
                    key: 'codigoReferencia',
                    sorter: true
                },

                {
                    title: 'Producto',
                    dataIndex: 'nombre',
                    key: 'nombre',
                    sorter: true
                },
                {
                    title: 'Lote',
                    dataIndex: 'lote',
                    key: 'lote',
                    sorter: true
                },
                {
                    title: 'Fecha Vencimiento',
                    dataIndex: 'fechaVencimiento',
                    key: 'fechaVencimiento',
                    sorter: true
                },
                {
                    title: 'Unidad de Medida',
                    dataIndex: 'nombreUnidadMedida',
                    key: 'nombreUnidadMedida',
                    sorter: true
                },
                {
                    title: 'Stock Actual',
                    dataIndex: 'stockActual',
                    key: 'stockActual',
                    sorter: true,
                    align: 'right',
                    render: (value) => (
                        <span>{global.decimalFormat(value.toFixed(3))}</span>
                    )
                },
                {
                    title: 'Stock Comprometido',
                    dataIndex: 'stockComprometido',
                    key: 'stockComprometido',
                    sorter: true,
                    align: 'right',
                    render: (value) => (
                        <span>{global.decimalFormat(value.toFixed(3))}</span>
                    )
                },
                {
                    title: 'Stock Disponible',
                    dataIndex: 'stockDisponible',
                    key: 'stockDisponible',
                    sorter: true,
                    align: 'right',
                    render: (value) => (
                        <span>{global.decimalFormat(value.toFixed(3))}</span>
                    )
                },
                {
                    title: 'Precio Promedio Soles',
                    dataIndex: 'precioPromedioSoles',
                    key: 'precioPromedioSoles',
                    sorter: true,
                    align: 'right',
                    render: (value) => (
                        <span>{global.decimalFormat(value.toFixed(3))}</span>
                    )
                },
                {
                    title: 'Costo Promedio Soles',
                    dataIndex: 'costoPromedioSoles',
                    key: 'costoPromedioSoles',
                    sorter: true,
                    align: 'right',
                    render: (value) => (
                        <span>{global.decimalFormat(value.toFixed(3))}</span>
                    )
                },
                {
                    title: 'Precio Promedio Dólares',
                    dataIndex: 'precioPromedioDolares',
                    key: 'precioPromedioDolares',
                    sorter: true,
                    align: 'right',
                    render: (value) => (
                        <span>{global.decimalFormat(value.toFixed(3))}</span>
                    )
                },
                {
                    title: 'Costo Promedio Dólares',
                    dataIndex: 'costoPromedioDolares',
                    key: 'costoPromedioDolares',
                    sorter: true,
                    align: 'right',
                    render: (value) => (
                        <span>{global.decimalFormat(value.toFixed(3))}</span>
                    )
                },
            ]}
        />
    );

}

